import axios from 'axios';
import { AtividadeCarro } from '../interfaces/AtividadeCarro';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const authHeader = (): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export type GetAtividadesCarroParams = {
  carId?: string;
  isActive?: boolean;
  esteiraId?: string;
};

export async function getAtividadesCarro(params: GetAtividadesCarroParams): Promise<AtividadeCarro[]> {
  const response = await axios.get(`${BACKEND_URL}/atividade-carro`, {
    params,
    headers: authHeader(),
    withCredentials: true,
  });
  return response.data;
}

export async function deleteAtividadeCarro(id: string): Promise<AtividadeCarro> {
  const response = await axios.delete(`${BACKEND_URL}/atividade-carro/${id}`, {
    headers: authHeader(),
    withCredentials: true,
  });
  return response.data;
}

/** at-89: seleção de sub-tarefas por esteira, enviada junto do planejamento. */
export interface SubtarefasDaEsteiraPayload {
  esteiraId: string;
  definicaoIds: string[];
}

/**
 * ⚠️ `subtarefas` é OMITIDO quando não há nada a declarar (at-89): o backend trata campo ausente
 * como "não mexa em sub-tarefa nenhuma". Enviar `[]` significaria "limpe a seleção de todas as
 * esteiras", que é o oposto.
 */
export async function bulkAtividadesCarro(
  carId: string,
  esteiraIds: string[],
  subtarefas?: SubtarefasDaEsteiraPayload[],
): Promise<AtividadeCarro[]> {
  const response = await axios.put(
    `${BACKEND_URL}/cars/${carId}/atividade-carro/bulk`,
    subtarefas ? { esteiraIds, subtarefas } : { esteiraIds },
    { headers: authHeader(), withCredentials: true },
  );
  return response.data;
}

